<script lang="ts">
    import { createAddress, getAddresses, updateAddress } from "../../../api"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import Table from "../../widgets/Table.svelte"
    import { _ } from "lodash"
    import { _ as _s } from "svelte-i18n"
    import { debounce } from "lodash"
    import hash from "object-hash"
    import { createEventDispatcher, onMount } from "svelte"
    const dispatch = createEventDispatcher()

    import { mdiFileDocumentEdit, mdiDelete, mdiPlusCircle } from "@mdi/js"
    import Icon from "./../../widgets/Icon.svelte"
    import { emptyAddressObj } from "../../../helperObjects.js"
    import Modal from "../../widgets/Modal.svelte"
    import ConfirmDeleteAddress from "./ConfirmDeleteAddress.svelte"
    import AddressForm from "../../widgets/AddressForm.svelte"
    import { newNotification } from "../../../store"

    export let company: Address
    export let addressFormModalShowed: boolean = false
    export let assignedPerson: string = ""
    let loading = false
    const gridBreakPoint = 1300
    let outerWidth = window.outerWidth
    let assignedAddresses: Address[] = []
    let sort = "-updateTime"
    let assignNewAddress: boolean = false
    let deleteModalShowed: boolean = false
    let personsSelector: boolean = false
    let addressFormModalWithPersonSelector: boolean = false

    let type = assignNewAddress ? "create" : "update"
    const emptyAddress = JSON.parse(JSON.stringify(emptyAddressObj))
    let selectedAssignedAddress = emptyAddress
    // @ts-ignore
    selectedAssignedAddress.person.parentCompany = company.id
    let originalAddress = JSON.parse(JSON.stringify(selectedAssignedAddress))
    const getActionButtons: () => TableButton<"address">[] = () => [
        {
            label: "Bearbeiten",
            className: "btn-edit-address",
            svgPath: mdiFileDocumentEdit,
            onClick(assignedAddress) {
                openAddressForm(assignedAddress)
            },
            getTooltip(address) {
                return {
                    content: $_s("address.editAddress"),
                }
            },
        },
        {
            label: "Löschen",
            className: "btn-delete-address",
            svgPath: mdiDelete,
            onClick(assignedAddress) {
                deleteAssignedAddress(assignedAddress)
            },
            getTooltip(address) {
                return {
                    content: $_s("address.delete"),
                }
            },
        },
    ]

    const openAddressForm = (assignedAddress?: Address, withPersonSelector?: boolean): void => {
        addressFormModalShowed = true
        addressFormModalWithPersonSelector = withPersonSelector
        deleteModalShowed = false
        personsSelector = assignedAddress ? false : true
        assignNewAddress = assignedAddress ? false : true
        type = assignNewAddress ? "create" : "update"

        if (assignedAddress) selectedAssignedAddress = JSON.parse(JSON.stringify(assignedAddress))
        else {
            selectedAssignedAddress = JSON.parse(JSON.stringify(emptyAddressObj))
            selectedAssignedAddress.person.parentCompany = company.id
            selectedAssignedAddress.type = "person"
            selectedAssignedAddress.company.name = company?.company?.name || ""
            selectedAssignedAddress.location.street = company?.location?.street
            selectedAssignedAddress.location.houseNumber = company?.location?.houseNumber
            selectedAssignedAddress.location.postcode = company?.location?.postcode
            selectedAssignedAddress.location.city = company?.location?.city
            selectedAssignedAddress.location.country = company?.location?.country
        }
        selectedAssignedAddress.notModifyablePCalc = true
        selectedAssignedAddress.priceCalculation = company.priceCalculation
        originalAddress = JSON.parse(JSON.stringify(selectedAssignedAddress))
    }

    const deleteAssignedAddress = (assignedAddress: Address): void => {
        selectedAssignedAddress = assignedAddress
        originalAddress = JSON.parse(JSON.stringify(selectedAssignedAddress))
        deleteModalShowed = true
    }

    const assignmentRemoved = (e: CustomEvent): void => {
        loadAssignedPersons(company.id)
        assignedAddresses = []
        deleteModalShowed = false
        addressFormModalShowed = false
        assignNewAddress = null
        originalAddress = null
    }

    const loadAssignedPersons = (id: string | undefined) => {
        addressFormModalWithPersonSelector = false

        if (!id) {
            return
        }
        loading = true
        return getAddresses(
            {
                type: "person",
                "person.parentCompany": id,
            },
            null,
            null,
            null,
            sort
        )
            .then((response) => {
                assignedAddresses = response.data
            })
            .finally(() => {
                loading = false
            })
    }

    if (company && !assignedAddresses.length) {
        loadAssignedPersons(company.id)
    }
    $: {
        loadAssignedPersons(company.id)
    }
    onMount(() => {
        outerWidth = window.outerWidth
    })

    let addressFormElement: HTMLFormElement
    let updateFormDataByAddress: (data: Address) => Promise<void>
    let resetForm: () => void
    let parentCompany: Address

    const updateLocationAndContactFieldsByAddress = (selectedAddress: Address, a: Address) => {
        selectedAddress.location = {}
        selectedAddress.location.street = a?.location?.street
        selectedAddress.location.houseNumber = a?.location?.houseNumber
        selectedAddress.location.supplement = a?.location?.supplement
        selectedAddress.location.postcode = a?.location?.postcode
        selectedAddress.location.city = a?.location?.city
        selectedAddress.location.country = a.location?.country
    }
    let showSuccess = false
    const updateAddressDebounce = debounce((selectedAddress: Address, parentCompany: Address) => {
        loading = true
        if (!selectedAddress) return
        selectedAddress.notModifyablePCalc = true
        selectedAddress.priceCalculation = company.priceCalculation
        if (type === "create" || type === "create-assignment") {
            createAddress(selectedAddress)
                .then((response) => {
                    newNotification({
                        class: "success",
                        html:
                            selectedAddress.type == "person"
                                ? $_s("address.addPersonSuccess")
                                : $_s("address.addAddressSuccess"),
                        timeout: 3000,
                    })
                    addressFormModalShowed = false
                    // @ts-ignore
                    selectedAddress = emptyAddress
                    loadAssignedPersons(company.id)
                    dispatch("refresh-addresses")
                    addressFormModalShowed = false
                    assignNewAddress = false
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html:
                            selectedAddress.type == "person"
                                ? $_s("address.addPersonError")
                                : $_s("address.addAddressError"),
                        timeout: 3000,
                    })
                })
                .finally(() => {
                    loading = false
                    addressHash = hash(selectedAddress)
                })
        } else if (type === "update" || type === "update-assignment") {
            if (parentCompany) {
                updateLocationAndContactFieldsByAddress(selectedAddress, parentCompany)
            }
            updateAddress(selectedAddress)
                .then((response) => {
                    showSuccess = true
                    // @ts-ignore
                    selectedAddress = emptyAddress
                    setTimeout(() => {
                        showSuccess = false
                    }, 2000)
                    loadAssignedPersons(company.id)
                    dispatch("refresh-addresses")
                    addressFormModalShowed = false
                    assignNewAddress = false
                })
                .finally(() => {
                    loading = false
                    addressHash = hash(selectedAddress)
                })
        }
    }, 100)

    let addressHash = hash(selectedAssignedAddress)
    const submitAddressFrom = (v: any) => {
        if (addressHash === hash(selectedAssignedAddress)) return
        if (!addressFormElement.checkValidity()) {
            addressFormElement.reportValidity()

            newNotification({
                class: "error",
                html: $_s("address.fillRequiredFields"),
            })
            return
        }
        if (assignNewAddress && v === true) {
            updateAddressDebounce(selectedAssignedAddress, parentCompany)
        } else if (!assignNewAddress) {
            updateAddressDebounce(selectedAssignedAddress, parentCompany)
        }
    }
    $: if (assignedPerson) {
        let assignedAddress = assignedAddresses.find((a) => a.id == assignedPerson)
        if (assignedAddress) {
            openAddressForm(assignedAddress, true)
            assignedPerson = ""
        }
    }
    $: addressHash = hash(originalAddress)
    $: addressChanged = addressHash !== hash(selectedAssignedAddress)
    let askForClose = false
    function closeRequest() {
        addressFormModalShowed = false
        assignNewAddress = null
        askForClose = false
    }
</script>

<svelte:window bind:outerWidth />

<section class="assigned-addresses">
    <div class="headline">{$_s("address.contactPerson")}</div>

    {#if assignedAddresses.length}
        <Table
            className="address-book"
            rows="{assignedAddresses}"
            gridview="{outerWidth <= gridBreakPoint}"
            bind:sort
            negativeTop="{true}"
            columns="{[
                {
                    label: $_s('address.salutation'),
                    field: 'person.salutation',
                    sortable: true,
                    className: 'mw-40 w-40 max-w-80',
                },
                {
                    label: $_s('address.firstname'),
                    field: 'person.firstname',
                    sortable: true,
                },
                {
                    label: $_s('address.lastname'),
                    field: 'person.lastname',
                    sortable: true,
                },
                {
                    label: $_s('address.street'),
                    field: 'location.street',
                    sortable: true,
                },
                {
                    label: $_s('address.houseNumber'),
                    field: 'location.houseNumber',
                    sortable: true,
                    className: 'mw-40 w-40 max-w-60',
                },
                {
                    label: $_s('address.supplement'),
                    field: 'location.supplement',
                    sortable: true,
                    className: 'mw-100 w-100',
                },
                {
                    label: $_s('address.postcode'),
                    field: 'location.postcode',
                    sortable: true,
                    className: 'mw-80 w-80',
                },
                {
                    label: $_s('address.city'),
                    field: 'location.city',
                    sortable: true,
                },
                {
                    label: $_s('address.country'),
                    field: 'location.country',
                    sortable: true,
                },
                {
                    label: $_s('address.customerNumber'),
                    field: 'customerNumber',
                    sortable: true,
                },
            ]}"
            buttonsColumn="{{
                label: 'Aktionen',
                className: 'mw-120 w-120',
            }}"
            buttons="{getActionButtons()}"
            on:click="{(e) => {
                openAddressForm(e.detail, false)
            }}"
        />
    {/if}

    {#if loading}
        <div class="centerbutton">
            <MiniLoader />
        </div>
    {/if}

    <div class="centerbutton">
        <div class="new-contact-person">
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                on:click|stopPropagation="{() => {
                    assignNewAddress = true
                    type = assignNewAddress ? 'create' : 'update'
                    openAddressForm(null, true)
                }}"
                on:keydown
            >
                <Icon path="{mdiPlusCircle}" size="32px" />
            </div>
            <div>{$_s("address.newContact")}</div>
        </div>
    </div>
</section>

<Modal
    show="{addressFormModalShowed}"
    size="md"
    on:close="{() => {
        if (addressChanged && addressFormModalShowed) {
            askForClose = true
        } else {
            closeRequest()
        }
    }}"
>
    <div slot="header">
        {#if assignNewAddress}
            {$_s("address.setNewEntry")}
        {:else}
            {$_s("address.editEntry")}
        {/if}
    </div>
    <div>
        <AddressForm
            bind:formData="{selectedAssignedAddress}"
            bind:formElement="{addressFormElement}"
            bind:updateFormDataByAddress
            bind:resetForm
            on:submit="{submitAddressFrom}"
            mustBePerson="{true}"
            readonly="{false}"
            cartId="DasisteierandomID"
            disableCompanyFields="{true}"
            showPriceCalcSelect="{true}"
            saveManually="{true}"
            on:mounted="{(e) => {
                originalAddress = JSON.parse(JSON.stringify(selectedAssignedAddress))
            }}"
        >
            <div style="width: 100%; display: flex; justify-content: space-between;">
                {#if !assignNewAddress}
                    <button
                        class="btn btn-secondary"
                        on:click|preventDefault="{() => (deleteModalShowed = true)}"
                        name="delete"
                    >
                        {$_s("address.deleteContact")}
                    </button>
                {:else}
                    <div></div>
                {/if}
                <div style="display: flex; gap: 10px;">
                    {#if showSuccess}
                        <div style="color: green; font-size: 0.7rem; display: flex; align-items: flex-end;">
                            {$_s("general.dataStored")}
                        </div>
                    {/if}
                    <div style="display: flex; flex-direction: column;  position: relative;">
                        {#if addressChanged && selectedAssignedAddress?.id}
                            <button
                                type="button"
                                data-cy="cancel"
                                style="border: 0px; padding: 0px; background: transparent; position: absolute; top: -20px;"
                                on:click="{() => {
                                    selectedAssignedAddress = JSON.parse(JSON.stringify(originalAddress))
                                    addressChanged = false
                                }}"
                            >
                                {$_s("address.reset")}
                            </button>
                        {/if}
                        {#key addressChanged}
                            <div>
                                <button
                                    disabled="{!addressChanged}"
                                    class="btn"
                                    data-cy="save"
                                    on:click="{() => submitAddressFrom(true)}"
                                >
                                    {$_s("general.save")}
                                </button>
                            </div>
                        {/key}
                    </div>
                </div>
            </div>
        </AddressForm>
    </div>
</Modal>
{#if askForClose}
    <Modal
        show="{true}"
        on:close="{() => {
            askForClose = false
        }}"
        showCloseIcon="{false}"
    >
        <div slot="header">{$_s("address.closeAddress")}</div>
        <div>{$_s("address.unsavedChanges")}</div>
        <div slot="footer">
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    askForClose = false
                }}">{$_s("general.no")}</button
            >
            <button
                class="btn"
                on:click="{() => {
                    closeRequest()
                }}">{$_s("general.yes")}</button
            >
        </div>
    </Modal>
{/if}
<ConfirmDeleteAddress
    address="{selectedAssignedAddress}"
    bind:show="{deleteModalShowed}"
    on:canceled="{() => (deleteModalShowed = false)}"
    on:address-updated="{assignmentRemoved}"
    on:address-deleted="{assignmentRemoved}"
/>
